import React, { useEffect, useState } from "react";
import { useSeason } from "../hooks/useSeason";
import "../css/SeasonEndNotice.css";

const SeasonEndNotice = () => {
  const { currentSeason, fetchCurrentSeason } = useSeason();
  const [daysRemaining, setDaysRemaining] = useState(null);
  const [hoursRemaining, setHoursRemaining] = useState(null);

  useEffect(() => {
    fetchCurrentSeason();
  }, []);

  useEffect(() => {
    if (!currentSeason) return;

    const calculateTimeRemaining = () => {
      const now = new Date();
      const endDate = new Date(currentSeason.end);

      const timeDiff = endDate - now;
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );

      setDaysRemaining(days);
      setHoursRemaining(hours);
    };

    calculateTimeRemaining();
    const interval = setInterval(calculateTimeRemaining, 1000 * 60 * 60); // Update every hour

    return () => clearInterval(interval);
  }, [currentSeason]);

  if (!currentSeason || daysRemaining === null || daysRemaining < 0)
    return null;

  const getTimeText = () => {
    if (daysRemaining > 30) {
      const endDate = new Date(currentSeason.end);
      return endDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        timeZone: "UTC",
      });
    } else if (daysRemaining === 0) {
      return `${hoursRemaining} ${hoursRemaining === 1 ? "hour" : "hours"}`;
    } else if (daysRemaining < 7) {
      return `${daysRemaining} ${daysRemaining === 1 ? "day" : "days"}`;
    } else {
      return `${daysRemaining} days`;
    }
  };

  const getTimeLabel = () => {
    return daysRemaining > 30 ? "on" : "in";
  };

  return (
    <div className="season-end-notice-container">
      <div className="season-end-notice-content">
        <span className="season-end-text">
          <strong>{currentSeason.name}</strong> ends {getTimeLabel()}{" "}
          <strong>{getTimeText()}</strong>
          <span
            className="season-info-icon"
            title="The leaderboard, inventories, coins, premium status, and other season-related features will reset after this period (See How To Play for more details)."
          >
            ?
          </span>
        </span>
      </div>
    </div>
  );
};

export default SeasonEndNotice;
